import React, { useRef } from "react";

import CardBackground from "./CardBackground";
import PostComponent from "./PostComponent";

const TimelineSection = () => {
  return (
    <div className="p-6">
      <PostComponent />
    </div>
  );
};

export default TimelineSection;
